export const SAVED_SCENES_KEY = 'countMeIn.scenes'
